<app-alerts />

@if (data$ | async; as data) {
  <app-user-form
    (submitClickEvent)="handleSubmitClick($event)"
    [data]="data" />
}
